import { render, staticRenderFns } from "./TradeItem.vue?vue&type=template&id=2831a8c4"
import script from "./TradeItem.vue?vue&type=script&lang=js"
export * from "./TradeItem.vue?vue&type=script&lang=js"
import style0 from "./TradeItem.vue?vue&type=style&index=0&id=2831a8c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports